<template>
  <div>
    <div 
      style="gap: 8px"
      class="d-flex flex-wrap white px-8 py-4 align-center"
      >
      <h1 class="mt-2">Asientos</h1>
    </div>

    <div>
      <v-tabs v-model="tabs">
        <v-tab>
          General
        </v-tab>
        <v-tab>
          Rendiciones
        </v-tab>
        <v-tab>
          Cobranzas
        </v-tab>
      </v-tabs>
    </div>

    <div
      class="px-2 mt-3"
      >
      <v-tabs-items 
        class="transparent"
        v-model="tabs">
        <v-tab-item>
          <general-list
            ></general-list>
        </v-tab-item>

        <v-tab-item>
          <div
            class="d-flex flex-row"
            style="gap: 12px"
            >
            <clients
              :paymentType="paymentType"
              @select="select"
              ></clients>

            <payments
              class="grow"
              :paymentType="paymentType"
              :client="client"
              ></payments>
          </div>
        </v-tab-item>

        <v-tab-item>
          <div
            class="d-flex flex-row"
            style="gap: 12px"
            >
            <clients
              :paymentType="paymentType"
              @select="select"
              ></clients>
            <tenant-payments
              class="grow"
              :paymentType="paymentType"
              :client="client"
              ></tenant-payments>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
const Payments = () => import('@/components/payments/Payments')
const TenantPayments = () => import('@/components/payments/tenants/Payments')
const Clients = () => import('@/components/payments/Clients')
const GeneralList = () => import('@/components/payments/general/List')

export default {
  data: () => ({
    paymentTypes: [null, 'owner', 'tenant'],
    client: null,
    tabs: 0
  }),

  computed: {
    paymentType () {
      return this.paymentTypes[this.tabs]
    }
  },

  methods: {
    select (selected) {
      this.client = selected
    }
  },

  components: {
    Payments,
    Clients,
    GeneralList,
    TenantPayments
  },
}
</script>
